import { render, staticRenderFns } from "./merchantNetMany.vue?vue&type=template&id=4cbf2240&scoped=true&"
import script from "./merchantNetMany.vue?vue&type=script&lang=js&"
export * from "./merchantNetMany.vue?vue&type=script&lang=js&"
import style0 from "./merchantNetMany.vue?vue&type=style&index=0&id=4cbf2240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf2240",
  null
  
)

export default component.exports